module.exports = __webpack_public_path__ + "img/collection-weddingRingsCheap@2x.787946c.webp";